import React, {useEffect} from 'react';
import { Banner} from '../components/Banner';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import WOW from 'wowjs';
import { Parallax } from 'react-parallax';
import { Testimonial } from '../components/carousels/Testimonial';
import { Partner } from '../components/carousels/Partner';
export const Home = () => {
    useEffect(()=>{
        new WOW.WOW({
            live:false,
        }).init()
}, [])
    return (
        <>
            <div id="content">
                <section className="shows">
                    <div className="container-fluid">
                        <div className="slider-banner">
                            <Banner />
                        </div>
                    </div>
                    <div className="container-fluid">
                        <div className="show">
                            <div className="row" data-wow-duration="2s">
                                <div className="col-sm-4 box-1">
                                    <div className="row wow animate__slideInRight" data-wow-duration="2s">
                                        <div className="col-sm-6">
                                            <div className="img">
                                                <img src={require('../images/banner-1-1.png')} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="title">
                                                <h2>Tire</h2>
                                                <p>Tires that we offer are of different types from passenger car tire to off-road tire.</p>
                                                <Link>
                                                    <Button className="btn btn-danger" type="button">View more</Button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-4 box-1">
                                    <div className="row wow animate__slideInRight" data-wow-duration="2s">
                                        <div className="col-sm-6">
                                            <div className="img">
                                                <img src={require('../images/banner-2-1.png')} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="title">
                                                <h2>WHEEL</h2>
                                                <p>We only distribute quality alloy wheel from original type to aftermarket type.</p>
                                                <Link>
                                                    <Button className="btn btn-danger" type="button">View more</Button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-4 box-1">
                                    <div className="row wow animate__slideInRight" data-wow-duration="2s">
                                        <div className="col-sm-6">
                                            <div className="img">
                                                <img src={require('../images/GMi68-international-nomad-cambodia-product-highlight.png')} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="title">
                                                <h2>LUBRICANT</h2>
                                                <p>No matter what car you are using, we always have the best lubricant type for you.</p>
                                                <Link>
                                                    <Button className="btn btn-danger" type="button">View more</Button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="tires">
                    <div className="container container1440">
                        <div className="tire">
                            <div className="box-tire">
                                <div className="boxLeft">
                                    <div className="title">
                                        <h3>Welcome</h3>
                                        <h2>Who We Are</h2>
                                        <p>GMi68 international is professional tire distributor in Cambodia and we have successfully operated in this market more than 5 year. We have a highly-qualified team work, 3 warehouses around the country and best delivery service to satisfy customer around the country. To response to market needs, we recently import and distribute Nomad lubricant from Dubai and alloy wheel from China.</p>
                                        <Link>
                                            <Button type="button" className="btn btn-danger">About</Button>
                                        </Link>
                                    </div>
                                </div>
                                <div className="boxRight">
                                    <div className="img wow animate__slideInLeft" data-wow-duration="4s">
                                        <img src={require('../images/GMi68-international-aboutus-home-01.jpg')} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="products">
                    <div className="container container1636">
                        <div className="product">
                            <div className="title">
                                <h3>Our Products</h3>
                                <h2>Download Product Catalogs</h2>
                            </div>
                            <div className="row">
                                <div className="col-sm-4 wow animate__bounceInUp" data-wow-duration="2s" data-wow-delay=".1s">
                                    <Link>
                                        <div className="img">
                                            <div className="text"></div>
                                            <h3>Tire</h3>
                                            <img src={require('../images/GMi68-international-durun-cambodia-catalog-FA-1.jpg')} alt="" />
                                            <div className="button">Download</div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-sm-4 wow animate__bounceInUp" data-wow-duration="2s" data-wow-delay=".5s">
                                    <Link>
                                        <div className="img">
                                            <div className="text"></div>
                                            <h3>Wheel</h3>
                                            <img src={require('../images/GMi68-international-wheel-cambodia-catalog-1.jpg')} alt="" />
                                            <div className="button">Download</div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="col-sm-4 wow animate__bounceInUp" data-wow-duration="2s" data-wow-delay=".9s">
                                    <Link>
                                        <div className="img">
                                            <div className="text"></div>
                                            <h3>lubricant</h3>
                                            <img src={require('../images/GMi68-international-nomad-cambodia-catalog.jpg')} alt="" />
                                            <div className="button">Download</div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="services">
                    <div className="container container1440">
                        <div className="service">
                            <Parallax bgImage={require("../images/Durun-Tire-Banner-01-1.jpg")} bgImageAlt="Services" strength={600}>
                                <div className="service-banner">
                                    <div className="text">
                                        <h3>Services</h3>
                                        <h2>What we offer</h2>
                                    </div>
                                </div>
                            </Parallax>
                        </div>
                    </div>
                    <div className="container container1636">
                        <div className="list">
                            <div className="row">
                                <div className="col-sm-4">
                                    <div className="img">
                                        <img src={require('../images/GMi68-international-nomad-cambodia-dealer-around-nation-1.png')} alt="" />
                                    </div>
                                    <div className="texts">
                                        <h3>DEALER AROUND THE NATION</h3>
                                        <p>To our customer, no matter where you are, you can find us anywhere near you, because more than 300 dealer around the country.</p>

                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="img">
                                        <img src={require('../images/GMi68-international-nomad-cambodia-dealer-around-nation-04.jpg')} alt="" />
                                    </div>
                                    <div className="texts">
                                        <h3>DELIVER AND INSTALLATION</h3>
                                        <p>For your convenience, you can just give us a call then we will tell you where and when to go, because we have best delivery service</p>

                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="img">
                                        <img src={require('../images/GMi68-international-nomad-cambodia-dealer-around-nation-03.png')} alt="" />
                                    </div>
                                    <div className="texts">
                                        <h3>MAINTENANCE & WARRANTY</h3>
                                        <p>We sell you not only the product, but a warranty and maintenance service that you can find any of our dealer around the country.</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="advantages">
                    <div className="container container1440">
                        <div className="advantage">
                            <div className="title">
                                <h3>Advantages</h3>
                                <h2>Why Choose Us</h2>
                            </div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <div className="lists">
                                        <div className="list">
                                            <div className="boxs">
                                                <div className="box">
                                                    <h1>1</h1>
                                                </div>
                                            </div>
                                            <div className="text">
                                                <h3>Low Cost</h3>
                                                <p>We bring you the best quality tire with reasonable price.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="lists">
                                        <div className="list">
                                            <div className="boxs">
                                                <div className="box">
                                                    <h1>2</h1>
                                                </div>
                                            </div>
                                            <div className="text">
                                                <h3>Fast Delivery</h3>
                                                <p>Just give us a call, and you get what you need.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="img">
                                        <img src={require("../images/about_x2-1.png")} alt="" />
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="lists">
                                        <div className="list">
                                            <div className="boxs">
                                                <div className="box">
                                                    <h1>3</h1>
                                                </div>
                                            </div>
                                            <div className="text">
                                                <h3>Largest Range</h3>
                                                <p>We have more than 100 size of tire for your choice.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="lists">
                                        <div className="list">
                                            <div className="boxs">
                                                <div className="box">
                                                    <h1>4</h1>
                                                </div>
                                            </div>
                                            <div className="text">
                                                <h3>Large Team</h3>
                                                <p>If you don’t know what tire to use, come to us, because we technical and service team to help.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Testimonials */}
                <Testimonial/>

                <section className="medias">
                    <div className="container container1636">
                        <div className="lists-media">
                            <h3>Media</h3>
                            <h2>Relates New</h2>
                        </div>
                        <div className="lists">
                            <div className="row">
                                <div className="col-sm-4 wow animate__bounceInUp" data-wow-duration="2s" data-wow-delay="0.1s">
                                    <div className="box-list">
                                        <Link to="/">
                                            <div className="list">
                                                <div className="bg-cover"></div>
                                                <img src={require('../images/IMG_0857.jpg')} alt="" />
                                                <div className="text">
                                                    <div className="share"></div>
                                                </div>
                                            </div>
                                        </Link>
                                        <h3>Training Nomad</h3>
                                        <p>Date:<span> December 25, 2020</span></p>
                                    </div>
                                </div>
                                <div className="col-sm-4 wow animate__bounceInUp" data-wow-duration="2s" data-wow-delay="0.2s">
                                    <div className="box-list">
                                        <Link to="/">
                                            <div className="list">
                                                <div className="bg-cover"></div>
                                                <img src={require('../images/photo_2020-11-06_13-27-13.jpg')} alt="" />
                                                <div className="text">
                                                    <div className="share"></div>
                                                </div>
                                            </div>
                                        </Link>
                                        <h3>Effective Team Player Training</h3>
                                        <p>Date:<span> December 18, 2020</span></p>
                                    </div>
                                </div>
                                <div className="col-sm-4 wow animate__bounceInUp" data-wow-duration="2s" data-wow-delay="0.3s">
                                    <div className="box-list">
                                        <Link to="/">
                                            <div className="list">
                                                <div className="bg-cover"></div>
                                                <img src={require('../images/photo_2020-10-09_08-56-11.jpg')} alt="" />
                                                <div className="text">
                                                    <div className="share"></div>
                                                </div>
                                            </div>
                                        </Link>
                                        <h3>Effective Communication and powerful leadership style</h3>
                                        <p>Date:<span> December 18, 2020</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div id="footer">
                {/* Partner */}
                <Partner/>
                <section className="contact-us" id="contact">
				<div className="container">
					<div className="contact">
						<h3>CONTACT US</h3>
						<h2>FEEL FREE TO CONTACT US</h2>
						<div className="lists">
							<div className="row">
								<div className="col-sm-4">
									<div className="list">
										<div className="icon">
											<img src={require('../images/a.png')} alt=""/>
										</div>
									</div>
									<p className="address">#636, St. 271, Sangkat Boeung Tumpun 2, Khan Meanchey, Phnom Penh.</p>
								</div>
								<div className="col-sm-4">
									<div className="list">
										<div className="icon">
											<img src={require('../images/p.png')} alt="" />
										</div>
									</div>
									<p className="phone">
                                        <a href="tel:+855 92 777 734" title="">+855 92 777 734</a>
                                        <a href="tel:+855 81 222 224" title="">+855 81 222 224</a>
                                        <a href="tel:+855 76 555 8885" title="">+855 76 555 8885</a>
                                    </p>
                                    <div className="list">
								        <div className="img">
                                        <a href="https://www.facebook.com/gmi68international/" title="" target="_blank"><img src={require('../images/facebook-1.png')} alt=""/></a>
                                        <a href="https://www.facebook.com/gmi68international/" title="" target="_blank"><img src={require('../images/youtube-1.png')} alt=""/></a>
                                    </div>
							        </div>
								</div>
								<div className="col-sm-4">
									<div className="list">
										<div className="icon">
											<img src={require('../images/add.png')} alt=""/>
										</div>
									</div>
									<p className="email">
                                        <a href="mailto:168@gmi68international.com">168@gmi68international.com</a><br/>
                                        <a href="http://www.gmi68international.com.com">www.gmi68international.com.com</a>
                                    </p>
								</div>
							</div>
						</div>
						<p className="copyright">© 2019. All rights reserved. GMi68 International.</p>
			        	<p className="developed">Developed by: <a href="http://tomnerbtech.com/">TomnerbTECH</a></p>
					</div>
				</div>
		       
		    </section>
            </div>
        </>
    )
}